import * as zod from 'zod';

export const GPUTaskRunnerConfiguration = zod.object({
  kind: zod.literal('GPUTaskRunner'),
  name: zod.string().default('GPU Task Runner'),
  host: zod.string().default(''),
});

export type GPUTaskRunnerConfiguration = zod.infer<
  typeof GPUTaskRunnerConfiguration
>;

export const WRIST_CAMERA_CONFIGURATION_DEFAULT =
  GPUTaskRunnerConfiguration.parse({
    kind: 'GPUTaskRunner',
  });
